import { render, staticRenderFns } from "./EnrollForm.vue?vue&type=template&id=190e2ca2&scoped=true"
import script from "./EnrollForm.vue?vue&type=script&lang=js"
export * from "./EnrollForm.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "190e2ca2",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\daima\\daima\\health-store\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('190e2ca2')) {
      api.createRecord('190e2ca2', component.options)
    } else {
      api.reload('190e2ca2', component.options)
    }
    module.hot.accept("./EnrollForm.vue?vue&type=template&id=190e2ca2&scoped=true", function () {
      api.rerender('190e2ca2', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/business/page/treatment/treatment/patients/EnrollForm.vue"
export default component.exports